/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PreviewDatasetRowsPathParams = NonNullable<operations['previewDatasetRows']['parameters']['path']>;

export type PreviewDatasetRowsQueryParams = NonNullable<operations['previewDatasetRows']['parameters']['query']>;

export interface Input extends PreviewDatasetRowsPathParams {
  apiVersion?: string;
  query: PreviewDatasetRowsQueryParams;
}

export async function previewDatasetRows(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/datasets/{datasetId}/preview', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
